import { render, staticRenderFns } from "./Cytology.vue?vue&type=template&id=64a4cf1a&scoped=true&"
import script from "./Cytology.vue?vue&type=script&lang=js&"
export * from "./Cytology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4cf1a",
  null
  
)

export default component.exports